import { removeDatesFromLocalStorage } from "../../components/dms_common/DmsCommonServices";
import { AllSidebarOptions } from "../../configurations/allSidebarOptions";
import { convertToDashboardOptions } from "../../services/uiConfigService";
import { ConfigDashboardTypes, SidebarOptions } from "../../types";
import store from "../store";

export function updateActiveConfigType(activeConfigOption:string | undefined,activeSidebarOption?:string){
    const configDashboardTypes = store.getState().configTypeState.configDashboardTypes
    let optionsToBeSelected:ConfigDashboardTypes | undefined;
    if(activeSidebarOption){
        optionsToBeSelected = configDashboardTypes.find(configType=>{
            return configType.sidebarOptions.includes(activeSidebarOption)
        })
    }else if(activeConfigOption){
        optionsToBeSelected = configDashboardTypes.find(configType=>configType.id === activeConfigOption)
    }
    if(optionsToBeSelected){
        setActiveConfigType(optionsToBeSelected.id);
        const visibleSidebarOptions: SidebarOptions[] = optionsToBeSelected.sidebarOptions.map((sideBarOptionId) => {
            const sidebarObject = AllSidebarOptions.find((option) => {
                return option.id === sideBarOptionId
            })
            return sidebarObject
        }).filter((sideBarObject: SidebarOptions | undefined) => sideBarObject!==undefined) as SidebarOptions[];
        store.dispatch({
            type:"resetSidebarOptions",
            payload:{visibleSidebarOptions}
        })
        setActiveSidebar(activeSidebarOption ? activeSidebarOption : visibleSidebarOptions[0].id)
        const selectedSidebar = activeSidebarOption ? visibleSidebarOptions.find(option=>option.id === activeSidebarOption) : visibleSidebarOptions[0];
        return selectedSidebar;
    }
}

export function setActiveConfigType(activeOption:string){
    removeDatesFromLocalStorage(activeOption);
    store.dispatch({
        type:"setActiveConfigType",
        payload:{
            "activeOption":activeOption
        }
    })
}
export function setActiveSidebar(activeOption:string){
    store.dispatch({
        type:"setActiveSidebar",
        payload:{
            "activeOption":activeOption
        }
    })
}

export function resetConfigDashboardTypes(configTypes:{configDashboardTypes:ConfigDashboardTypes[]}){
    if(configTypes.configDashboardTypes.length === 0){
        configTypes.configDashboardTypes = convertToDashboardOptions();
    }
    store.dispatch({
        type:"resetConfigDashboardTypes",
        payload:configTypes
    })
}

export function clearConfigDashboardTypes(){
    store.dispatch({
        type:"clearConfigDashboardTypes",
        payload:{}
    })
}